"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  registerCheckmark: true,
  lottieMonumentLoading: true,
  searchingDocuments: true
};
Object.defineProperty(exports, "lottieMonumentLoading", {
  enumerable: true,
  get: function get() {
    return _lottieMonumentLoading.default;
  }
});
Object.defineProperty(exports, "registerCheckmark", {
  enumerable: true,
  get: function get() {
    return _registerCheckmark.default;
  }
});
Object.defineProperty(exports, "searchingDocuments", {
  enumerable: true,
  get: function get() {
    return _searchingDocuments.default;
  }
});
var _types = require("./types");
Object.keys(_types).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _types[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _types[key];
    }
  });
});
var _shared = require("./shared");
Object.keys(_shared).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _shared[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _shared[key];
    }
  });
});
var _components = require("./components");
Object.keys(_components).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _components[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _components[key];
    }
  });
});
var _utils = require("./utils");
Object.keys(_utils).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _utils[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _utils[key];
    }
  });
});
var _registerCheckmark = _interopRequireDefault(require("./images/registerCheckmark.json"));
var _lottieMonumentLoading = _interopRequireDefault(require("./images/lottieMonumentLoading.json"));
var _searchingDocuments = _interopRequireDefault(require("./images/searchingDocuments.json"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }